export const CATALOG_VARIANTS_PAGE_SIZE = 20;
export const CATALOG_FETCH_DATA_TIMEOUT = 500;
export const SHOPIFY_CATALOG_GROUP_TYPES = ['shopify_collection', 'shopify_tag'];
export const CATALOG_GROUP_TYPE_LABELS = {
  shopify_collection: 'Collection',
  shopify_tag: 'Tag',
  custom: 'Custom Collection'
};
